import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid'; // Grid version 1
import { contentTxt, selectActiveTxt, firstStepContainer } from '../styles/StepsStyles';
import { getAnalytics, logEvent } from '@firebase/analytics';
import { Checkbox, InputAdornment, TextField, ThemeProvider, createTheme } from '@mui/material';
import { IEkatenaState } from '../interfaces/ekatenaInterfaces';
import { PostEkatenaReport } from '../apis/ApiEkatenaReport';
import { Colors, Fonts } from '../utils/constants';
import { Button, Col, Image, Row, Spin, message } from 'antd';
import { useAppDispatch, useAppSelector } from '../hooks/storeHooks';
import { 
    getEkatenaId, 
    getSuccessEkatena, 
    getUserRFC,
    getUserType
} from '../reducer/slices/DataCotizador';
import { RegexRFCFisica, RegexRFCMoral } from '../utils/constants';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import styles from '../styles/Step.style';
import blueLogoSvg from '../assets/logos/blueLogoSvg.svg'
var CryptoJS = require('crypto-js');
var validator = require('validator');
const theme = createTheme({
    typography: {
        allVariants: {
            color: Colors.blue,
            fontFamily: Fonts.sspMedium
        }
    }
})
const useStyle = styles;
const Validate = () => { }
const EkatenaView = ({ children }: any) => {
    const [validateRFC, setValidateRFC] = useState<boolean | undefined>(undefined);
    const classes = useStyle();
    const dispatch = useAppDispatch();
    const { width } = useAppSelector(state => state.dimensions);
    const [{ rfc, ciec }, setEkatenaState] = useState<IEkatenaState>({ rfc: '', ciec: '' });
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [agreeTermsAndContiditions, setAgreeTermsAndContiditions] = useState(false);
    const analytics = getAnalytics();
    useEffect(() => {
        logEvent(analytics, "view_ekatena_screen");
    }, [])
    /**
     * @title onConnectWithEkatena
     * @description Validacion para envio Ekatena
     * @returns null
     */

    const onConnectWithEkatena = async () => {
        if (rfc === '' || rfc.length > 13 || rfc.length < 12) {
            message.destroy();
            message.error({ content: 'Es necesario agregar el RFC para continuar.', style: { fontFamily: Fonts.sspRegular } });
            return;
        }

        if (ciec === '' || ciec.length != 8) {
            message.destroy();
            message.error({ content: 'Es necesario colocar tu clave CIEC para continuar.', style: { fontFamily: Fonts.sspRegular } });
            return;
        }

        if (!agreeTermsAndContiditions) {
            message.destroy();
            message.error({ content: 'Es necesario estar de acuerdo con los Términos y condiciones y el Aviso de privacidad para poder continuar' });
            return;
        }

        setLoading(true);

        const { success, items: id, message: responseMssg } = await PostEkatenaReport(rfc, ciec);

        if (success) {
            message.success({ content: `¡Felicidades! Tu reporte de Ekatena ha sido generado exitosamente con el id: ${id}`, style: { fontFamily: Fonts.sspRegular } })
            dispatch(getUserRFC(rfc));
            dispatch(getUserType(rfc.length === 13 ? 1 : 0));
            dispatch(getEkatenaId(id));
            setSuccess(true);
            dispatch(getSuccessEkatena(true));
        } else {
            message.error({ content: responseMssg, style: { fontFamily: Fonts.sspRegular } });
        }
        setLoading(false);
    }
    return (
        <>
            <ThemeProvider theme={theme}>
                <Row style={firstStepContainer}>
                    <p style={{ ...selectActiveTxt, textAlign: 'center', width: '80%', marginInline: 'auto' }}>
                        FinBe ABC se conectará ahora a tu cuenta del SAT mediante Ekatena
                    </p>
                    <div style={{ marginTop: '20', marginBottom: 'auto' }}>
                        <p style={{ ...contentTxt, marginBottom: 35 }}>
                            Con el objetivo de agilizar el proceso de preautorización, FinBe ABC puede acceder al Sistema de Administración Tributaria (SAT)
                            a través de la plataforma Ekatena para consultar y descargar su información fiscal.
                        </p>
                        <p style={{ ...contentTxt, marginBottom: 35 }}>
                            Este proceso nos permite recuperar información como el nivel de ingresos de los últimos meses o el cumplimiento de sus obligaciones
                            fiscales, ahorrándole mucho tiempo de revisión y análisis para generar la información necesaria durante este proceso de calificación
                            y preautorización.
                        </p>
                        <p style={contentTxt}>
                            Solamente accediendo mediante sus credenciales personales en la siguiente sección, podrá autorizar a FinBe ABC hacer uso de esta
                            información para continuar con el proceso de una forma más rápida y eficiente.
                        </p>
                        </div>
                </Row>
                <div className={classes.ContainerEkatena}>
                    <Spin spinning={loading}>
                        <Grid container gap={5} style={{ marginTop: 20, justifyContent:'center', textAlign: 'center', width: width > 400 ? 280 : 200 }}>
                            <Grid item xs={10} style={{ alignSelf: 'flex-end' }}>
                                <Image
                                    preview={false}
                                    width='90%'
                                    alt='Ekatena'
                                    src={blueLogoSvg}
                                />
                            </Grid>
                        </Grid>
                        <Row justify='center' className={classes.ContentViewEkatena}>
                            <Col>
                                <TextField
                                    label='R.F.C'
                                    fullWidth
                                    value={rfc}
                                    className={classes.textInputEkatena}
                                    style={width > 400 ? {width: 280} : {width: 200}}
                                    onChange={({ target }) => {
                                    setEkatenaState({ ciec, rfc: target.value.toUpperCase() })
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row className={classes.ContentViewEkatena} justify='center' >
                            <Col>
                            <TextField
                                    label='CIEC'
                                    fullWidth
                                    onCut={(e) => e.preventDefault()}
                                    onCopy={(e) => e.preventDefault()}
                                    onPaste={(e) => e.preventDefault()}
                                    value={ciec}
                                    type={showPassword ? "text" : "password"}
                                    className={classes.textInputEkatena}
                                    style={width > 400 ? {width: 280} : {width: 200}}
                                    onChange={({ target }) => setEkatenaState({ rfc, ciec: target.value })}
                                    InputProps={{
                                        endAdornment:
                                        (<InputAdornment
                                        position='end'
                                        onClick={() => setShowPassword(!showPassword)}>
                                        {
                                            showPassword ? (
                                                <EyeOutlined style={{ color: Colors.blue, cursor: "pointer" }} />
                                                    ) :
                                                    (
                                                    <EyeInvisibleOutlined style={{ color: Colors.blue, cursor: "pointer" }} />
                                                    )
                                        }
                                            </InputAdornment>)
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row justify='center'>
                            <Button
                                shape='round'
                                className={classes.continueBttn}
                                onClick={onConnectWithEkatena}
                            >
                                Conectar
                            </Button>
                        </Row>
                        <Row justify='center' className={classes.checkBoxEkatena} style={width > 400 ? {width: 280} : {width: 200}}>
                            <Checkbox
                                defaultChecked
                                style={{
                                    color: '#323F48',
                                }}
                                checked={agreeTermsAndContiditions}
                                onClick={() => setAgreeTermsAndContiditions(!agreeTermsAndContiditions)}
                            />
                            <p className={classes.labelTerminosEkatena}>
                                Estoy de acuerdo con los {' '}
                                <a target='_blank' href='https://www.ekatena.com/terminos.html'>Términos y condiciones</a>
                                <br /> y el <a target='_blank' href='https://www.ekatena.com/aviso.html'>Aviso de privacidad</a>
                            </p>
                            <Grid container gap={5} style={{ marginTop: 20, justifyContent:'center', textAlign: 'center', width: width > 400 ? 280 : 200 }}>
                                <Grid item xs={5} style={{ alignSelf: 'flex-start' }}>
                                    <Image
                                        preview={false}
                                        width='90%'
                                        alt='Ekatena'
                                        src={require('../assets/logos/ekatena.png')}
                                    />
                                </Grid>  
                            </Grid>  
                        </Row>
                    </Spin>
                </div>
            </ThemeProvider>
        </>
    )
}

export default EkatenaView;